/** @format */
import { HeaderCheckBoxSelectListElement } from './listTableHeader/HeaderCheckBoxSelectList';

const _ = require('underscore');

export const numberStateIdMapInt = {
    FREE: 0,
    USED: 1,
    PLANNED: 2,
    LOCK: 3,
    ARCHIVE: 4,
    E14_SEND: 5,
    E14_RETRIEVED: 6,
};

export const numberStateIdMapI18n = {
    FREE: 'pools:state.free',
    USED: 'pools:state.used',
    FREE_M: 'pools:state.free_m',
    USED_M: 'pools:state.used_m',
    PLANNED: 'pools:state.planned',
    LOCK: 'pools:state.lock',
    ARCHIVE: 'pools:state.archive',
    E14_SEND: 'pools:state.e14_send',
    E14_RETRIEVED: 'pools:state.e14_retrieved',
};

export class MsisdnStateHelper {
    getStatus = (): Array<HeaderCheckBoxSelectListElement> => {
        return [
            { value: numberStateIdMapInt.FREE, name: numberStateIdMapI18n.FREE },
            { value: numberStateIdMapInt.USED, name: numberStateIdMapI18n.USED },
            { value: numberStateIdMapInt.PLANNED, name: numberStateIdMapI18n.PLANNED },
            { value: numberStateIdMapInt.LOCK, name: numberStateIdMapI18n.LOCK },
            { value: numberStateIdMapInt.ARCHIVE, name: numberStateIdMapI18n.ARCHIVE },
            { value: numberStateIdMapInt.E14_SEND, name: numberStateIdMapI18n.E14_SEND },
            { value: numberStateIdMapInt.E14_RETRIEVED, name: numberStateIdMapI18n.E14_RETRIEVED },
        ];
    };

    getStatusList = (): Array<HeaderCheckBoxSelectListElement> => {
        return [
            { value: numberStateIdMapInt.ARCHIVE, name: numberStateIdMapI18n.ARCHIVE },
            { value: numberStateIdMapInt.LOCK, name: numberStateIdMapI18n.LOCK },
            { value: numberStateIdMapInt.PLANNED, name: numberStateIdMapI18n.PLANNED },
            { value: numberStateIdMapInt.FREE, name: numberStateIdMapI18n.FREE },
            { value: numberStateIdMapInt.USED, name: numberStateIdMapI18n.USED },
        ];
    };

    getStatusListM = (): Array<HeaderCheckBoxSelectListElement> => {
        return [
            { value: numberStateIdMapInt.ARCHIVE, name: numberStateIdMapI18n.ARCHIVE },
            { value: numberStateIdMapInt.LOCK, name: numberStateIdMapI18n.LOCK },
            { value: numberStateIdMapInt.PLANNED, name: numberStateIdMapI18n.PLANNED },
            { value: numberStateIdMapInt.FREE, name: numberStateIdMapI18n.FREE_M },
            { value: numberStateIdMapInt.USED, name: numberStateIdMapI18n.USED_M },
        ];
    };
}
